<template>
  <div class="login">
    <div class="header">
      <div class="logo">
        <img src="../../static/headlogo.png" alt="" />
        <p>北京中国国际展览中心（新馆） | 2023年10月25-28日</p>
      </div>
      <div class="logo2">
        <img src="../../static/title_logo.png" />
      </div>
    </div>
    <div class="loginfrom">
      <div class="exit">
        <p>返回首页</p>
        <p>En</p>
      </div>
      <div class="title">
        <h3>欢迎登录</h3>
        <p>中国国际采矿展线上展会站上个人中心</p>
        <el-form
          ref="form"
          class="form"
          :model="sizeForm"
          label-width=""
          size="mini"
        >
          <el-form-item label=" ">
            <el-input
              placeholder="请输入内容"
              prefix-icon="el-icon-user"
              v-model="sizeForm.username"
            >
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-input
              placeholder="请输入内容"
              prefix-icon="el-icon-lock"
              v-model="sizeForm.password"
            >
            </el-input>
          </el-form-item>
          <el-checkbox v-model="checked">我已经阅读并同意</el-checkbox>
          <span @click="agreement1">展商系统用户须知及免责条款。</span>

          <el-button
            type="primary"
            class="button"
            @click="submitForm('sizeForm')"
            >登录</el-button
          >
        </el-form>
        <p>没有账号? <span>参展申请</span></p>
        <p>
          <i>*</i> 用户名和密码由展会组委会提供，如有任何疑问可以致电展会组
          委会，<span>010-84293556</span>
        </p>
      </div>
    </div>
    <div class="alert" v-if="agreement">
      <i class="el-icon-close" @click="close"></i>
      <h3>展商系统 – 系统用户须知&免责条款</h3>
      <div class="wenzhang1">
        <h5>系统用户须知</h5>
        <p>
          系统用户应确保在本系统中所上传或填写的信息（包括公司介绍等）真实有效，相关宣传内容应符合相关法律法规（包括但不限于广告法、反不正当竞争法等）。
        </p>
        <p>
          系统用户应确保向中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司提供的数据真实有效，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司可以为了提供本系统服务内容而将该信息转交给第三方，也可以为实现其商业目的而处理和使用系统用户提供的数据；但前提是前述使用应遵守数据保护的相关法律。系统用户确认并承诺其向中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司提供的相关数据的来源合法，且其对该等数据的使用已取得相关数据主体的授权同意
        </p>
        <p>
          系统用户应确保所上传的资料（包括文字、logo，图片等）均不侵犯任何第三方知识产权及其他合法权利，包括但不限于商标权、著作权、专利权及肖像权等。
        </p>
        <p>
          系统用户如对上述有任何违反，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司有权修改、删除相关内容或停止向展商提供服务，系统用户应对该违反情况承担全部责任，并赔偿中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司因此造成的一切损失（包括但不限于对第三方的赔偿、罚款等）。
        </p>
      </div>
      <div class="wenzhang1">
        <h5>免责声明</h5>
        <p>
          本系统内容由展商提供，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对内容的正确性、完整性和最新状态承担任何责任。
        </p>
        <p>
          本系统中包含第三方外部网站的链接，我们无法控制这些网站的内容。在任何情况下，相关网站提供者或运营者须对链接网站的内容负责，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对此承担任何责任。
        </p>
        <p>
          中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司特别保留权利更改或扩展本系统所提供内容，恕不另行通知。您基于由本系统或经本系统提供的信息作出决定，须自行承担风险。中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对因使用由本系统或经本系统提供的信息造成的任何直接或间接损失承担赔偿责任。
        </p>
        <p>
          对任何因直接或间接使用本系统内容而造成的任何损失，包括但不限于因有关内容有错误、遗漏、病毒等而导致的损失，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对此承担任何法律责任。
        </p>
        <p>
          本系统中有关展商的信息、图片、logo等均由相应展商提供，不得擅自下载或使用。如您有异议，请联中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sizeForm: {
        username: "",
        password: "",
      },
      checked: false,
      agreement:false
    };
  },
  create() {},
  methods: {
    submitForm(formName) {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      //       alert("submit!");
      //     } else {
      //       console.log("error submit!!");
      //       return false;
      //     }
      //   });
      this.$router.push("/backIndex/homeIndex");
    },
    agreement1() {
      console.log("打开协议");
      this.agreement=true;
    },
    close(){
      this.agreement=false
    }

  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 945px;
  padding: 35px 0 0 0;
  position: relative;
  background: url("../../static/logobj.png") no-repeat;
  // border:1px solid red;
  .header {
    display: flex;
    justify-content: space-between;

    padding: 0 53px;
    margin-bottom: 54px;
    .logo {
      width: 616px;
      height: 150px;

      p {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        margin-left: 98px;
        margin-top: 18px;
      }
      img {
        width: 616px;
        height: 114px;
      }
    }
    .logo2 {
      img {
        width: 161px;
        height: 40px;
      }
    }
  }

  .loginfrom {
    width: 490px;
    height: 549px;
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0px 5px 7px 0px rgba(139, 139, 139, 0.5);
    border-radius: 12px;
    border: 1px solid;
    margin: 0 auto;
    padding: 44px 70px;
    box-sizing: border-box;
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 18px;
      line-height: 19px;
      i {
        color: red;
      }
    }
    span {
      color: #006fb8;
      font-size: 12px;
      cursor: pointer;
    }
    .exit {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-bottom: 36px;
    }
    .title {
      h3 {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #006fb8;
        margin-bottom: 18px;
      }
    }
    .form {
      margin: 0 auto;
      width: 350px;
      margin-top: 44px;
      span {
        color: #006fb8;
      }
      .button {
        width: 350px;
        height: 35px;
        background: #006fb8;
        margin-top: 44px;
      }
    }
  }
  .alert {
    width: 980px;
    height: 697px;
    // border: 1px solid red;
    position: absolute;
    top: 120px;
    left: 343px;
    background: white;
    box-sizing: border-box;
    padding: 0 26px 26px 26px;
    h3 {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 37px;
      margin-bottom: 26px;
      text-align: center;
      margin-top: 61px;
    }
    h5 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      margin-bottom: 17px;
       text-align: center;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-indent: 2rem;
    }
    .wenzhang1{
      margin-bottom: 26px;
    }
    .el-icon-close {
      float: right;
    }
  }
}
</style>
<style scoped>
.form >>> .el-input__inner {
  height: 35px;
}
</style>
